import Avatar from './Home/Avatar/Avatar';
import Profile from '../../Me/Profile/Profile';

export const Home = () => {
  return (
    <>
      <Avatar />
      <Profile />
    </>
  );
};

export default Home;
